import { __resetStyles, __styles, mergeClasses } from '@griffel/react';
import { tokens } from '@fluentui/react-theme';
export const treeClassNames = {
  root: 'fui-Tree'
};
const useBaseStyles = /*#__PURE__*/__resetStyles("rnv2ez3", null, [".rnv2ez3{display:flex;flex-direction:column;row-gap:var(--spacingVerticalXXS);}"]);
const useStyles = /*#__PURE__*/__styles({
  subtree: {
    z8tnut: "fclwglc"
  }
}, {
  d: [".fclwglc{padding-top:var(--spacingVerticalXXS);}"]
});
export const useTreeStyles_unstable = state => {
  'use no memo';

  const baseStyles = useBaseStyles();
  const styles = useStyles();
  const isSubTree = state.level > 1;
  state.root.className = mergeClasses(treeClassNames.root, baseStyles, isSubTree && styles.subtree, state.root.className);
  return state;
};
//# sourceMappingURL=useTreeStyles.styles.js.map